import heuritechMin from './files/logos/heuritech_min.svg';
import heuritechMax from './files/logos/heuritech_max.svg';

export default {
  heuritechMin,
  heuritechMax,
};
